/* global angular swal _ */
export default function($log, $stateParams, ApiClass, $location, $q, Swal) {
  'ngInject';
  $log.debug('Event Manger Invitations view activated');
  const vm = this;

  vm.update = ({ location }) => {
    if (!location) return;
    vm.location = location;
    vm.usersInvites = angular.copy(vm.location.invitations || []).filter(({ rsvp }) => !rsvp);
    vm.eventRegistrants = angular.copy(vm.location.attendees || []).filter(({ email }) => !!email);
    vm.eventWaitlist = angular.copy(vm.location.waitlist || []).filter(({ email }) => !!email);
    vm.isPastEvent = new Date(vm.event.delivery_date) < new Date();
    $location.search('location', location.location);
  };

  vm.sendInvitations = ({ data, includeRelatedEvents, oneClickRegistration }) => {
    const id = $stateParams.eventid;
    return ApiClass.eventsIdTypePut(
      { id, type: 'invites' },
      {
        includeRelatedEvents,
        location: vm.location.location,
        primaryEventId: id,
        oneClickRegistration,
        users: data
      },
      { queryParams: { manage: true } }
    ).then(response => {
      const {
        data: { existingInvitations, failedInvitations }
      } = response;
      return $q(resolve => {
        if (existingInvitations && existingInvitations.length) {
          return resolve(
            Swal.alert(
              'Already invited',
              `The following users have already been invited to take this course: ${existingInvitations.join(' ,')}`
            )
          );
        }

        resolve();
      }).then(() => {
        return $q((resolve, reject) => {
          if (failedInvitations && failedInvitations.length) {
            return reject(
              Swal.alert(
                'Invitations failed',
                `The following invitations failed to be created: ${failedInvitations.join(' ,')}`
              )
            );
          }
          resolve(response);
        });
      });
    });
  };

  vm.addRegistrants = ({ data, suppress, inFirm = false, location }) => {
    const id = $stateParams.eventid;
    return ApiClass.eventsIdTypePut(
      { id, type: 'attendees' },
      { users: data, location: location || vm.location.location, suppressEmail: !!suppress, inFirm },
      { queryParams: { manage: true } }
    );
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/events/event/eventManager.js